module.exports = __webpack_public_path__ + "static/media/moengage.eb96fa72.svg";